import React, { Component } from 'react';
import DoctorList from './DoctorList';
import DoctorSave from './DoctorSave';
import { connect } from 'react-redux';
import { showError } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';

//DoctorPage renders LIST or SAVE views of doctors
class DoctorPage extends Component {
    constructor(props, context) {
        super(props, context);

    }

    componentWillMount() {
        if (!this.props.isMedical) {
            this.props.showError(LOOKUP.authentication.unauthorizedMessage);
            this.props.navigate('/');
        }
    }

    //change the page to the SAVE view form by pushing the add route
    callAddDoctorForm() {
        this.props.navigate("/doctor/add");
    }
    //change the page to the LIST view form by pushing the add route
    cancelForm() {
        this.props.navigate("/doctor");
    }
    //function only called when the Patient creation is SUCCEEDED
    doctorCreated() {
        this.props.navigate("/doctor");
    }

    render() {
        //check for the view type LIST or SAVE
        //LIST - when we dont have the doctorId or the route name is not '/doctor/add'
        //SAVE - when we receive the doctorId or the route name is '/doctor/add'

        const doctorId = this.props.params.id;
        const isSave = doctorId || this.props.location.pathname === "/doctor/add";
        return (
            <div>
                {
                    isSave ?
                        <DoctorSave name="doctor"
                            params={this.props.params}
                            cancel={this.cancelForm}
                            onDoctorCreated={this.doctorCreated} />
                        :
                        <DoctorList callAddDoctorForm={this.callAddDoctorForm} />
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isMedical: state.common.applicationSettings.isMedical
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (message) => dispatch(showError(message))
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(DoctorPage));